import PropTypes from 'prop-types';
import React from 'react';
import CommentListCollapsable from './CommentListCollapsable/CommentListCollapsable.container';
import CreateCommentFeed from './CreateComment/CreateComment.container';
import styles from './styles';

class CommentsFeed extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showComments: false,
    };

    this.handleComment = this.handleComment.bind(this);
  }

  handleComment() {
    this.setState({
      showComments: true,
    });
  }

  render() {
    const { postId, readOnly } = this.props;
    const { showComments } = this.state;

    return (
      <div style={styles.commentsFeed}>
        <CommentListCollapsable
          postId={postId}
          ref={(r) => {
            this.commentList = r;
          }}
          showComments={showComments}
        />
        {!readOnly && (
          <CreateCommentFeed postId={postId} didComment={this.handleComment} />
        )}
      </div>
    );
  }
}

CommentsFeed.propTypes = {
  postId: PropTypes.string.isRequired,
  readOnly: PropTypes.bool.isRequired,
};

export default CommentsFeed;
